/**
 * Logo corporativo de ES Group.
 *
 * Hay dos versiones del logo —una para fondo claro y otra para fondo oscuro— y se
 * elige la adecuada. Por defecto se decide por el tema de la interfaz; sobre una
 * superficie que siempre es oscura (la barra del back-office) se fuerza la versión
 * oscura con `forzarOscuro`.
 *
 * Los ficheros se sirven desde `public/`:
 *   - public/es-group-claro.png    (para fondo claro)
 *   - public/es-group-oscuro.png   (para fondo oscuro)
 * Mientras no estén, el componente no pinta nada (ni el logo ni su divisor), en
 * lugar de dejar el icono de imagen rota.
 */

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import { useEffect, useState } from 'react'

import { useTema } from '../contexto/Tema'

export function LogoEsGroup({
  alto = 34,
  forzarOscuro = false,
  conDivisor = false,
}: {
  alto?: number
  forzarOscuro?: boolean
  conDivisor?: boolean
}) {
  const { modo } = useTema()
  const oscuro = forzarOscuro || modo === 'dark'
  const [error, setError] = useState(false)

  // Al cambiar de versión (por el tema) se reintenta la carga: si una faltaba y
  // la otra existe, el logo debe aparecer en lugar de quedarse oculto.
  useEffect(() => {
    setError(false)
  }, [oscuro])

  if (error) return null
  return (
    <>
      <Box
        component="img"
        src={oscuro ? '/es-group-oscuro.png' : '/es-group-claro.png'}
        alt="ES Group"
        onError={() => setError(true)}
        sx={{ height: alto, width: 'auto', display: 'block', flex: 'none' }}
      />
      {conDivisor && <Divider orientation="vertical" flexItem />}
    </>
  )
}
